<div class="card">
  <div class="card-header">
    <h2>
      <strong>ngxWaveSurfer Component </strong><br /><span style="font-weight: 100"
        >&#x3C;ngx-wavesurfer&#x3E;&#x3C;/ngx-wavesurfer&#x3E;</span>
    </h2>
  </div>
  <div class="card-body">
    <app-single-ngx-wavesurfer-component
      audioURL="/assets/example.mp3">
    </app-single-ngx-wavesurfer-component>
  </div>
  <div class="usage">

    <b>Usage</b>
    <ul>
      <li>Only place a single ngx-wavesurfer component per host component</li>
      <li>Inject the ngx-wavesurfer service</li>
      <li>Declare the service as a provider in the host component</li>
      <li>This instance's WaveSurfer object is available via waveSurferService.WaveSurfer</li>
    </ul>
  </div>
  <h4>Code</h4>
  <a href="https://stackblitz.com/edit/ngx-wavesurfer-component-demo?file=src/app/ngx-wavesurfer-component-demo/ngx-wavesurfer-component-demo.component.html" target="_blank"><button class="stackblitz"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightning-charge" viewBox="0 0 16 16">
    <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41 4.157 8.5z"/>
  </svg> Edit this on Stackblitz</button></a>
  <pre class="language-javascript">
{{ code }}
</pre>
</div>
